// import 'react-aspect-ratio/aspect-ratio.css';
import { TrophyIcon } from '@infl-ts/ui-advocate-icons';
import { Box } from '@mui/material';
import ReactAspectRatio from 'react-aspect-ratio';
import { CloudflareImage } from '../cloudflare-image';
import { jsx as _jsx } from "react/jsx-runtime";

var ChallengeCardImage = function ChallengeCardImage(_ref) {
  var banner = _ref.banner,
      name = _ref.name;
  return /*#__PURE__*/_jsx(ReactAspectRatio, {
    ratio: "3/2",
    style: {
      maxWidth: 'auto',
      margin: 'auto',
      height: '100%'
    },
    "data-element": "ReactAspectRatio",
    "data-component": "ChallengeCardImage",
    "data-source-file": "challenge-card-image.tsx",
    children: banner ? /*#__PURE__*/_jsx(CloudflareImage, {
      id: banner.id,
      blurhash: banner.blurhash,
      sx: {
        height: '156px'
      },
      alt: name
    }) : /*#__PURE__*/_jsx(Box, {
      sx: {
        background: function background(t) {
          return t.palette.secondary.background;
        },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      children: /*#__PURE__*/_jsx(TrophyIcon, {
        sx: {
          width: 64,
          height: 64,
          fill: function fill(t) {
            return t.palette.secondary.dark;
          }
        }
      })
    })
  });
};

export default ChallengeCardImage;